import type { ChartType, DataMode, IncompatibleDetail } from "./types.js";

const ALLOWED: Record<ChartType, readonly DataMode[]> = {
  bar_chart: ["BarChart"],
  line_chart: ["LineChart"],
  horizontal_bar_chart: ["HorizontalBarChart"],
  split_horizontal_bar: ["HorizontalBarChart"],
  average_returns: ["AverageReturns"],
  statistics: ["Statistics"],
  holdings: ["Holdings"],
};

export function allowedModesForChart(type: ChartType): DataMode[] {
  return [...ALLOWED[type]];
}

export function isChartCompatible(type: ChartType, mode: DataMode): boolean {
  return (ALLOWED[type] as readonly DataMode[]).includes(mode);
}

export function makeIncompatibleDetail(
  chartType: ChartType,
  sourceId: string,
  sourceMode: DataMode
): IncompatibleDetail {
  return {
    chartType,
    sourceId,
    sourceMode,
    allowedModes: allowedModesForChart(chartType),
  };
}
